import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/node_modules/next-video/dist/components/video.js");
;
import(/* webpackMode: "eager" */ "/onedev-build/work/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/onedev-build/work/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/onedev-build/work/src/app/components/AnimatedBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/Animation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/animations/ComparisonAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/home/BouncyDoughnutsLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/home/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/home/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/home/HomeAnimator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/home/HoverShowMoreCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/home/ProcessSectionAnimator.jsx");
;
import(/* webpackMode: "eager" */ "/onedev-build/work/src/app/components/HorizontallyScrollableSection.tsx");
;
import(/* webpackMode: "eager" */ "/onedev-build/work/src/app/components/LeviButton.tsx");
